module.exports = __webpack_public_path__ + "img/apple-app-qr-code.8aa0d9e2.png";